import { useEffect, useState } from 'react'
import * as actions from '../../../store/slices'
import useDebounce from '../../../hooks/useDebounce'
import { useDispatch, useSelector } from 'react-redux'

const useGetStateAndCity = ({ onChange }) => {
  const [activeSection, setActiveSection] = useState(null)
  const [selectedState, setSelectedState] = useState('')
  const [selectedCity, setSelectedCity] = useState('')
  const [filteredStateList, setFilteredStateList] = useState([])

  const dispatch = useDispatch()
  const {
    stateList: {
      data: stateList,
      loading: stateListLoading,
      error: stateListError,
    },
    cityList: {
      data: cityList,
      loading: cityListLoading,
      error: cityListError,
    },
  } = useSelector((state) => state.carePlan)

  const getStateList = (search = '') => {
    dispatch(actions.getStateListRequest({ search }))
  }
  const getCityList = (stateId, search = '') => {
    dispatch(
      actions.getCityListByStateRequest({
        state_id: stateId,
        search: search,
      }),
    )
  }

  const [formFields, setFormFields] = useState({
    state: '',
    city: '',
  })
  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    getStateList()
  }, [])

  useEffect(() => {
    if (activeSection === 'state' && stateList.length < 0) {
      getStateList()
    } else if (activeSection === 'city') {
      getCityList(selectedState?.state_master_id)
    }
  }, [activeSection])

  const handleChange = (key, value) => {
    setFormFields({ ...formFields, [key]: value })
  }

  const searchCities = (query) => {
    if (activeSection === 'city') {
      getCityList(selectedState?.state_master_id, query)
    } else if (activeSection === 'state') {
      getStateList(query)
    }
  }

  useEffect(() => {
    if (stateList && activeSection === 'state' && stateList.length > 0) {
      setFilteredStateList(stateList)
    }
  }, [stateList, activeSection])

  const searchState = (query) => {
    if (!query) {
      getStateList()
      return
    }
    const filteredStates = stateList?.filter((state) =>
      state.state_name.toLowerCase().includes(query.toLowerCase()),
    )
    setFilteredStateList(filteredStates)
  }

  const debouncedSearch = useDebounce(searchCities, 1000)
  const debouncedStateSearch = useDebounce(searchState, 1000)

  const handleOnSearch = (event) => {
    const query = event.target.value
    setSearchQuery(query)
    debouncedSearch(query)
  }

  const handleCityClick = (item, name) => {
    if (activeSection === 'city') {
      setSelectedCity(item)
    } else if (activeSection === 'state') {
      setSelectedCity(() => '')
      setSelectedState(item)
    }
    onChange(activeSection, name)
    setActiveSection(null)
    setSearchQuery('')
  }

  const handleOnStateSearch = (event) => {
    const query = event.target.value
    setSearchQuery(query)
    debouncedStateSearch(query)
  }

  return {
    cityList,
    stateList,
    searchQuery,
    selectedCity,
    activeSection,
    selectedState,
    cityListError,
    stateListError,
    cityListLoading,
    stateListLoading,
    filteredStateList,
    handleChange,
    handleOnSearch,
    handleCityClick,
    setActiveSection,
    handleOnStateSearch,
    setSelectedState,
    setSelectedCity,
  }
}

export default useGetStateAndCity
